import { Vue } from "@/vue.setup"
import mixins from "@/mixins"
import ProblemCard from "@/components/ProblemCard"




!!(() => {
    new Vue({
        el: "#app",
        mixins,
        components: {
            ProblemCard,
        },
    });
})();
